import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin, Globe } from 'lucide-react';
import { useCountry } from '../context/CountryContext';
import { useData } from '../context/DataContext';

const Footer = () => {
  const { detectedCountry, clearCountry } = useCountry();
  const { countries } = useData();
  
  const currentCountry = countries?.find(c => c.code === detectedCountry);

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Logo y descripción */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img src="/iso-logo-tuclinicapp.png" alt="TuClinicApp Logo" className="h-8 w-8" />
              <span className="text-2xl font-bold text-white">Tu ClinicApp</span>
            </div>
            <p className="text-gray-400 mb-4">
              Tu directorio de confianza para encontrar las mejores clínicas dentales en Bolivia, Paraguay y El Salvador.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/tuclinicapp" className="hover:text-cyan-500 transition-colors">
                <Facebook className="h-5 w-5" />
              </a> 
              <a href="#" className="hover:text-cyan-500 transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              {/* <a href="#" className="hover:text-cyan-500 transition-colors">
                <Linkedin className="h-5 w-5" />
              </a> */}
            </div>
          </div>

          {/* Especialidades */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Especialidades</h3>
            <ul className="space-y-2">
              <li><Link to="/clinicas?especialidad=ortodoncia" className="hover:text-cyan-500 transition-colors">Ortodoncia</Link></li>
              <li><Link to="/clinicas?especialidad=implantologia" className="hover:text-cyan-500 transition-colors">Implantología</Link></li>
              <li><Link to="/clinicas?especialidad=estetica-dental" className="hover:text-cyan-500 transition-colors">Estética Dental</Link></li>
              <li><Link to="/clinicas?especialidad=endodoncia" className="hover:text-cyan-500 transition-colors">Endodoncia</Link></li>
              <li><Link to="/clinicas?especialidad=odontopediatria" className="hover:text-cyan-500 transition-colors">Odontopediatría</Link></li>
            </ul>
          </div>

          {/* Países */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Países</h3>
            
            {/* Mostrar país seleccionado actualmente */}
            {detectedCountry && currentCountry && (
              <div className="mb-4 p-3 bg-gray-800 rounded-lg border border-gray-700">
                <div className="flex items-center space-x-2 mb-2">
                  <Globe className="h-4 w-4 text-cyan-500" />
                  <span className="text-sm text-gray-400">Tu ubicación:</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="font-semibold text-white">
                    {currentCountry.flag} {currentCountry.name}
                  </span>
                  <button
                    onClick={clearCountry}
                    className="text-xs text-cyan-400 hover:text-cyan-300 underline transition-colors"
                  >
                    Cambiar
                  </button>
                </div>
              </div>
            )}
            
            <ul className="space-y-2">
              <li><Link to="/clinicas?pais=BO" className="hover:text-cyan-500 transition-colors">🇧🇴 Bolivia</Link></li>
              <li><Link to="/clinicas?pais=PY" className="hover:text-cyan-500 transition-colors">🇵🇾 Paraguay</Link></li>
              <li><Link to="/clinicas?pais=SV" className="hover:text-cyan-500 transition-colors">🇸🇻 El Salvador</Link></li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Mail className="h-5 w-5 text-cyan-500 mt-0.5" />
                <span>info@tuclinicapp.com</span>
              </li>
              <li className="flex items-start space-x-2">
                <Phone className="h-5 w-5 text-cyan-500 mt-0.5" />
                <span>+591 6902896</span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="h-5 w-5 text-cyan-500 mt-0.5" />
                <span>Disponible en América Latina</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2026 TuClinicApp. Todos los derechos reservados.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link to="/terminos-condiciones" className="hover:text-cyan-500 transition-colors">Términos y Condiciones</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
